export const UPDATES_CALL = 'UPDATES_CALL';
export const UPDATES_RESPONSE = 'UPDATES_RESPONSE';
export const ADD_UPDATE = 'ADD_UPDATE';
export const UPDATES_SEEN_CALL = 'UPDATES_SEEN_CALL';